import React, { useCallback, useEffect, useState } from 'react';
import { CardBase } from '@components/organisms';
import {
    Grid,
    Typography,
    useMediaQuery,
    Button,
    CircularProgress,
    FormControlLabel,
    Checkbox,
} from '@material-ui/core';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronCircleLeft, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { ImgGallery } from '@components/molecules';
import moment from 'moment';
import { UpdateCertificate } from './index';
import { CredentialsService } from "@services";
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';

// redux actions
import { saveSelectedCertImageData } from "@store/certificates";

const useStyles = makeStyles(theme => ({
    smallContainer: {
        [theme.breakpoints.down('xs')]: {
            width: '100%',
            marginLeft: 0,
        },
        [theme.breakpoints.up('sm')]: {
            width: '50%',
            height: 440,
            overflowY: 'scroll',
            marginLeft: theme.spacing(1),
        },
    },
    spacing: {
        marginBottom: theme.spacing(0.5),
    },
    iconColor: {
        color: theme.palette.primary.main,
    },
    // mobileButtonsContainer: {
    //     [theme.breakpoints.down('xs')]: {
    //         justifyContent: 'space-between',
    //     },
    //     display: 'flex',
    //     justifyContent: 'center',
    //     paddingTop: theme.spacing(1),
    // },
    label: {
        textTransform: 'capitalize',
    },
    hidden: {
        [theme.breakpoints.up('sm')]: {
            display: 'none',
        },
    },
    hiddenSmall: {
        [theme.breakpoints.down('xs')]: {
            display: 'none',
        },
    },
    center: {
        display: 'flex',
        justifyContent: 'center',
        padding: 10,
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: '65%',
        justifyContent: 'space-between',
    },
    padding: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
    closeButton: {
        display: 'flex',
        justifyContent: 'flex-end',
        cursor: 'pointer',
    },
    closeIconColor: {
        color: theme.palette.primary.main,
    },
    whiteSpace: {
        whiteSpace: "pre-line",
    },
}));

const ItemDetailsBase = ({ certificateDetails, handleBack }) => {
    const classes = useStyles();
    const theme = useTheme();
    const dispatch = useDispatch();
    const { user } = useSelector(state => state.user);
    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });

    const [openModal, setOpenModal] = useState(false);
    const [showNav, setShowNav] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [images, setImages] = useState([])

    const loadImages = useCallback(() => {
        setIsLoading(true);
        const payload = {
            employeeID: user?.employeeNumber,
            certificateID: certificateDetails.certificateID,
            fileID: certificateDetails.fileID,
            fileIDFront: certificateDetails.fileIDFront,
            fileIDBack: certificateDetails.fileIDBack,
            disposition: certificateDetails.disposition,
            employeeCertificatesID: certificateDetails.employeeCertificatesID
        };
        CredentialsService.getCertificateImage(payload)
            .then(certImage => {
                dispatch(saveSelectedCertImageData(certImage));
                setImages([{ original: `data:${certImage.certificateType};base64,` + certImage.certificateImage }]);
            })
            .then(() => {
                setIsLoading(false);
            })
            .catch(e => {
                setIsLoading(false);
                console.log(e);
            })
    }, [certificateDetails]);

    const showImageNav = useCallback(() => {
        if (images.length > 1) {
            setShowNav(true);
        } else {
            setShowNav(false);
        }
    }, []);

    useEffect(() => {
        loadImages();
        showImageNav();
    }, [certificateDetails, loadImages, showImageNav]);
    return (
        <>
            <CardBase className={classes.smallContainer}>
                <Grid container flex alignItems="center">
                    <Grid item md={4} />
                    <Grid item xs={6} sm={6} md={4}>
                        {/* {
                            certificateDetails.certificateName === "Respiratory Medical Clearance" ||
                            certificateDetails.certificateName === "Respiratory Fit Test" ||
                            certificateDetails.certificateName === "EVOC" ||
                            certificateDetails.certificateName === "Safety Stretcher Handling" ?
                                <Button variant="text" color="primary" className={classes.label}>Read Only</Button>
                                : */}
                        <Button variant="outlined" color="primary" className={classes.label} onClick={() => setOpenModal(true)}>
                            {/MISSING/i.test(certificateDetails.disposition) ? 'Add' : 'Renew'}
                        </Button>
                        {/* } */}
                    </Grid>
                    <Grid item xs={6} sm={6} md={4}>
                        <div className={classes.closeButton} onClick={handleBack}>
                            <FontAwesomeIcon
                                icon={faTimesCircle}
                                size="2x"
                                className={classes.closeIconColor}
                            />
                        </div>
                    </Grid>
                </Grid>
                <Grid container flex spacing={isMd ? 4 : 2} style={{ marginTop: '10px' }}>
                    <Grid item xs={12}>

                        <div className={classes.spacing}>
                            <Typography variant="h6" color="primary">Credential Type</Typography>
                            <Typography variant="body2" className={classes.whiteSpace}>{certificateDetails.certificateName}</Typography>
                        </div>
                        {
                            !/MISSING/i.test(certificateDetails.disposition) && (
                                <>
                                    {certificateDetails.manufacturer && (
                                        <div className={classes.spacing}>
                                            <Typography variant="h6" color="primary">Manufacturer</Typography>
                                            <Typography variant="body2" className={classes.label}>{certificateDetails.manufacturer}</Typography>
                                        </div>
                                    )}
                                    {certificateDetails.stateCode && (
                                        <div className={classes.spacing}>
                                            <Typography variant="h6" color="primary">State</Typography>
                                            <Typography variant="body2">{certificateDetails.stateCode}</Typography>
                                        </div>
                                    )}
                                    {certificateDetails.countyName && (
                                        <div className={classes.spacing}>
                                            <Typography variant="h6" color="primary">County</Typography>
                                            <Typography variant="body2">{certificateDetails.countyName}</Typography>
                                        </div>
                                    )}
                                    {certificateDetails.certificateID === "1007" && certificateDetails?.lotNumber && (
                                        <div className={classes.spacing}>
                                            <Typography variant="h6" color="primary">Lot Number</Typography>
                                            <Typography variant="body2">{certificateDetails.lotNumber}</Typography>
                                        </div>
                                    )}
                                    {(certificateDetails.certificateID === "1007") && certificateDetails?.isVaccineDeclined === '1' && (
                                        <div className={clsx(classes.spacing, classes.row)}>
                                            <Typography variant="h6" color="primary">Unvaccinated</Typography>
                                            <FormControlLabel
                                                control={<Checkbox checked={certificateDetails.isVaccineDeclined === '0' ? false : true} color="primary" disabled />}
                                            />
                                        </div>
                                    )}

                                    {(certificateDetails.certificateID === "259") && certificateDetails?.isVaccineDeclined === '1' && (
                                        <div className={clsx(classes.spacing, classes.row)}>
                                            <Typography variant="h6" color="primary">Declined</Typography>
                                            <FormControlLabel
                                                control={<Checkbox checked={certificateDetails.isVaccineDeclined === '0' ? false : true} color="primary" disabled />}
                                            />
                                        </div>
                                    )}
                                    {certificateDetails.documentNumber && certificateDetails.documentNumber !== "NA" && (
                                        <div className={classes.spacing}>
                                            <Typography variant="h6" color="primary">Credential Number</Typography>
                                            <Typography variant="body2">{certificateDetails.documentNumber.includes(':') ? certificateDetails.documentNumber.split(':')[0] : certificateDetails.documentNumber}</Typography>
                                        </div>
                                    )}
                                    {certificateDetails.modelNumber && (
                                        <div className={classes.spacing}>
                                            <Typography variant="h6" color="primary">Model Number</Typography>
                                            <Typography variant="body2">{certificateDetails.modelNumber}</Typography>
                                        </div>
                                    )}
                                    {certificateDetails.respiratorType && (
                                        <div className={classes.spacing}>
                                            <Typography variant="h6" color="primary">Respirator Type</Typography>
                                            <Typography variant="body2">{certificateDetails.respiratorType}</Typography>
                                        </div>
                                    )}
                                    {certificateDetails.respiratorSize && (
                                        <div className={classes.spacing}>
                                            <Typography variant="h6" color="primary">Respirator Size</Typography>
                                            <Typography variant="body2">{certificateDetails.respiratorSize}</Typography>
                                        </div>
                                    )}
                                    {certificateDetails.testResults && (
                                        <div className={classes.spacing}>
                                            <Typography variant="h6" color="primary">Test Results</Typography>
                                            <Typography variant="body2">{certificateDetails.testResults}</Typography>
                                        </div>
                                    )}
                                    {certificateDetails.issueDate && (
                                        <div className={classes.spacing}>
                                            <Typography variant="h6" color="primary">Issue Date</Typography>
                                            <Typography variant="body2">{moment(certificateDetails.issueDate).format('MM/DD/YYYY')}</Typography>
                                        </div>
                                    )}
                                    {certificateDetails.expirationDate && (
                                        <div className={classes.spacing}>
                                            <Typography variant="h6" color="primary">Expiration Date</Typography>
                                            <Typography variant="body2">{moment(certificateDetails.expirationDate).format('MM/DD/YYYY')}</Typography>
                                        </div>
                                    )}
                                    <div className={classes.padding}>
                                        {images.length ?
                                            <ImgGallery images={images} showNav={showNav} fullscreen={true} />
                                            : <span>No images available</span>}
                                    </div>
                                </>
                            )
                        }



                        {isLoading && (
                            <div className={classes.center}>
                                <CircularProgress color="primary" size={75} />
                            </div>
                        )}

                        {/* <div className={classes.mobileButtonsContainer}>
                            <Button variant="text" onClick={handleBack} className={classes.hidden}>
                                <FontAwesomeIcon
                                    icon={faChevronCircleLeft}
                                    size="2x"
                                    className={classes.iconColor}
                                />
                            </Button>
                        </div> */}

                    </Grid>
                </Grid>
            </CardBase >
            {openModal && (
                <>
                    <UpdateCertificate
                        certificateDetails={certificateDetails}
                        openModal={openModal}
                        setOpenModal={setOpenModal}
                    />
                </>
            )}
        </>
    );
};

export default ItemDetailsBase;
